import ReactDOM from "react-dom";

/**
 * https://github.com/react-component/util/tree/master/src/Dom
 *
 * @param target
 * @param eventType
 * @param cb
 * @param options
 */

function addEventListener(
  target: any,
  eventType: string,
  cb: (...args: any) => any,
  options?:
    | {
        capture?: boolean;
        once?: boolean;
        passive?: boolean;
      }
    | boolean,
) {
  /* eslint camelcase: 2 */
  const callback = ReactDOM.unstable_batchedUpdates
    ? function run(e: any) {
        ReactDOM.unstable_batchedUpdates(cb, e);
      }
    : cb;
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, options);
  }
  return {
    remove: () => {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback, options);
      }
    },
  };
}
export default addEventListener;